import { render, staticRenderFns } from "./Tab4.vue?vue&type=template&id=6a4f63ee&scoped=true"
import script from "./Tab4.vue?vue&type=script&lang=js"
export * from "./Tab4.vue?vue&type=script&lang=js"
import style0 from "./Tab4.vue?vue&type=style&index=0&id=6a4f63ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f63ee",
  null
  
)

export default component.exports